import { FC } from 'react';
import PolicyContent from 'shared/components/PolicyContent';
import usePolicyData from 'shared/hooks/usePolicyData';

const CashoutPromoPolicy: FC = () => {
	const policyData = usePolicyData('CASHOUT');

	return <PolicyContent policyData={policyData} />;
};

export default CashoutPromoPolicy;
